import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layouts
import Layout from './components/Layout';
import FormanLayout from './components/Layout/FormanLayout';
import NonAuthLayout from './components/Layout/NonAuthLayout';

// Auth Pages
import Login from './pages/Auth/Login';

// Dashboard
import Dashboard from './pages/Dashboard';

// Forman Pages
import FormanDashboard from './pages/Forman/FormanDashboard';
import FormanQRScanner from './pages/Forman/FormanQRScanner';
import FormanDailyRecord from './pages/Forman/FormanDailyRecord';

// Waybills
import WaybillList from './pages/Waybills/WaybillList';
import QRScanner from './pages/Waybills/QRScanner';

// Daily Records
import DailyRecordList from './pages/DailyRecords/DailyRecordList';
import DailyRecordForm from './pages/DailyRecords/DailyRecordForm';
import DailyRecordDetail from './pages/DailyRecords/DailyRecordDetail';

// Projects
import ProjectList from './pages/Projects/ProjectList';
import SiteList from './pages/Projects/SiteList';
import SiteWorks from './pages/Projects/SiteWorks';
import SitePersonnel from './pages/Projects/SitePersonnel';

// Sites (standalone page)
import SiteListPage from './pages/Sites/SiteListPage';

// Vehicles
import VehicleList from './pages/Vehicles/VehicleList';

// Fuel
import FuelList from './pages/Fuel/FuelList';

// Personnel
import PersonnelList from './pages/Personnel/PersonnelList';
import PersonnelDetail from './pages/Personnel/PersonnelDetail';

// Reports
import Reports from './pages/Reports';

// Payroll
import PayrollReport from './pages/Payroll/PayrollReport';

// Personnel Leave
import PersonnelLeaveList from './pages/PersonnelLeave/PersonnelLeaveList';

// Settings
import Settings from './pages/Settings';

// Work Types
import WorkTypes from './pages/WorkTypes';

// Users
import UserList from './pages/Users/UserList';

// Auth Guards
import AuthGuard from './components/Common/AuthGuard';
import FormanGuard from './components/Common/FormanGuard';

const App: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<NonAuthLayout />}>
        <Route path="/login" element={<Login />} />
      </Route>

      {/* Forman Routes - Simplified Interface */}
      <Route element={<FormanGuard><FormanLayout /></FormanGuard>}>
        <Route path="/forman" element={<FormanDashboard />} />
        <Route path="/forman/qr-scan" element={<FormanQRScanner />} />
        <Route path="/forman/daily-record" element={<FormanDailyRecord />} />
      </Route>

      {/* Admin/Muhasebe Routes - Full Interface */}
      <Route element={<AuthGuard><Layout /></AuthGuard>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Waybills */}
        <Route path="/waybills" element={<WaybillList />} />
        <Route path="/waybills/scan" element={<QRScanner />} />

        {/* Daily Records */}
        <Route path="/daily-records" element={<DailyRecordList />} />
        <Route path="/daily-records/new" element={<DailyRecordForm />} />
        <Route path="/daily-records/:id" element={<DailyRecordDetail />} />

        {/* Projects */}
        <Route path="/projects" element={<ProjectList />} />
        <Route path="/sites" element={<SiteListPage />} />
        <Route path="/projects/:projectId/sites" element={<SiteList />} />
        <Route path="/sites/:siteId/works" element={<SiteWorks />} />
        <Route path="/sites/:siteId/personnel" element={<SitePersonnel />} />

        {/* Vehicles */}
        <Route path="/vehicles" element={<VehicleList />} />

        {/* Fuel */}
        <Route path="/fuel" element={<FuelList />} />

        {/* Personnel */}
        <Route path="/personnel" element={<PersonnelList />} />
        <Route path="/personnel/:id" element={<PersonnelDetail />} />

        {/* Reports */}
        <Route path="/reports" element={<Reports />} />

        {/* Payroll */}
        <Route path="/payroll" element={<PayrollReport />} />

        {/* Personnel Leave */}
        <Route path="/personnel-leave" element={<PersonnelLeaveList />} />

        {/* Settings */}
        <Route path="/settings" element={<Settings />} />

        {/* Work Types (Admin only) */}
        <Route path="/work-types" element={<WorkTypes />} />

        {/* Users (Admin only) */}
        <Route path="/users" element={<UserList />} />
      </Route>
    </Routes>
  );
};

export default App;
